import type { Project } from '@/services/types';

const SummaryTab = ({ data }: { data?: Project }) => {
  return (
    <div className='flex w-full flex-col flex-wrap space-y-6 break-words'>
      <div className='relative h-auto w-full max-w-full'>
        <p className='whitespace-pre-wrap break-words font-bold text-primary'>
          {data?.title}
        </p>
        <p className='whitespace-pre-wrap break-words text-muted-foreground'>
          {data?.summary}
        </p>
      </div>
    </div>
  );
};

export default SummaryTab;
